import {
  API_STUDENT,
  API_GET_ALL_PROGRESS_MEET,
  API_SAVE_PROGRESS_MEET_FEEDBACK,
  API_GET_PROGRESS_MEET_FEEDBACK,
  API_GET_MENTORSHIP_STATS,
  API_GET_CLASS_STATS,
  API_GET_EXAMS_STATS,
  API_CAPTURE_PROGRESS_MEET_ATTENDANCE,
  API_GET_PROGRESS_MEET_DETAILS,
  API_GET_PROGRESS_MEET_STATUS,
  API_SAVE_PROGRESS_MEET_FEEDBACK_EXTERNAL,
} from "core/constants/strings"
import { Server } from "core/utils/axios"
import ProgressMeetDataSource from "data/dataSource/Student/ProgressMeetDataSource"
import { Auth } from "domain/model/Auth"
import { ProgressMeet, ProgressMeetFeedback } from "domain/model/ProgressMeet"
import pn from "core/utils/pn"

const server = new Server()
export default class ProgressMeetAPIDataSourceImpl implements ProgressMeetDataSource {
  async getAllProgressMeets(auth: Auth): Promise<ProgressMeet[]> {
    try {
      const response = await server.get(pn(API_STUDENT, API_GET_ALL_PROGRESS_MEET), {
        Authorization: `Bearer ${auth?.id_token}`,
      })
      return response?.data?.data
    } catch (error) {
      throw new Error(`Failed to fetch progress meets: ${error}`)
    }
  }
  async fetchProgressMeetDetails(auth: Auth, meeting_id: any): Promise<any> {
    try {
      const response = await server.post(
        pn(API_STUDENT, API_GET_PROGRESS_MEET_DETAILS),
        { meeting_id },
        {
          Authorization: `Bearer ${auth?.id_token}`,
        }
      )
      return response?.data?.data
    } catch (error) {
      throw new Error(`Failed to fetch progress meets: ${error}`)
    }
  }
  async saveProgressMeetFeedback(auth: Auth, feedback: ProgressMeetFeedback): Promise<void> {
    try {
      const response = await server.post(pn(API_STUDENT, API_SAVE_PROGRESS_MEET_FEEDBACK), feedback, {
        Authorization: `Bearer ${auth?.id_token}`,
      })
      return response.data
    } catch (error) {
      throw new Error(`Failed to save progress meet feedback: ${error}`)
    }
  }

  async saveProgressMeetFeedbackExternal(feedback: ProgressMeetFeedback): Promise<any> {
    try {
      const response = await server.post(pn(API_STUDENT, API_SAVE_PROGRESS_MEET_FEEDBACK_EXTERNAL), feedback)
      return response
    } catch (error) {
      throw new Error(`Failed to save progress meet feedback: ${error}`)
    }
  }

  async getStudentProgressMeetFeedback(auth: Auth, meetingId: string): Promise<ProgressMeetFeedback> {
    try {
      const response = await server.post(
        pn(API_STUDENT, API_GET_PROGRESS_MEET_FEEDBACK),
        { meetingId },
        {
          Authorization: `Bearer ${auth?.id_token}`,
        }
      )

      return response?.data?.data
    } catch (error) {
      throw new Error(`Failed to fetch progress meets: ${error}`)
    }
  }
  async getMentorshipStats(auth: Auth, batches: string[], meetingDate: Number): Promise<any> {
    try {
      const response = await server.post(
        pn(API_STUDENT, API_GET_MENTORSHIP_STATS),
        { batches, meetingDate },
        {
          Authorization: `Bearer ${auth?.id_token}`,
        }
      )

      return response?.data?.data
    } catch (error) {
      throw new Error(`Failed to fetch progress meets: ${error}`)
    }
  }

  async getClassAttendanceStats(auth: Auth, batches: string[], meetingDate: Number): Promise<any> {
    try {
      const response = await server.post(
        pn(API_STUDENT, API_GET_CLASS_STATS),
        { batches, meetingDate },
        {
          Authorization: `Bearer ${auth?.id_token}`,
        }
      )

      return response?.data?.data
    } catch (error) {
      throw new Error(`Failed to fetch progress meets: ${error}`)
    }
  }
  async getExamStats(auth: Auth, batches: string[], meetingDate: Number): Promise<any> {
    try {
      const response = await server.post(
        pn(API_STUDENT, API_GET_EXAMS_STATS),
        { batches, meetingDate },
        {
          Authorization: `Bearer ${auth?.id_token}`,
        }
      )

      return response?.data?.data
    } catch (error) {
      throw new Error(`Failed to fetch progress meets: ${error}`)
    }
  }

  async captureProgressMeetAttendance(auth: Auth, meetingId: any): Promise<any> {
    try {
      const response = await server.post(
        pn(API_STUDENT, API_CAPTURE_PROGRESS_MEET_ATTENDANCE),
        { meetingId },
        {
          Authorization: `Bearer ${auth?.id_token}`,
        }
      )

      return response.data
    } catch (error) {
      throw new Error(`Failed to fetch progress meets: ${error}`)
    }
  }

  async fetchProgressMeetStatus(auth: Auth, meeting_id: any): Promise<any> {
    try {
      const response = await server.post(
        pn(API_STUDENT, API_GET_PROGRESS_MEET_STATUS),
        { meeting_id },
        {
          Authorization: `Bearer ${auth?.id_token}`,
        }
      )
      return response?.data?.is_attended
    } catch (error) {
      throw new Error(`Failed to fetch progress meets: ${error}`)
    }
  }
}
